/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ChangeRequestResult = {
    id?: number;
    jan?: string;
    itemName?: string;
    imageUrl?: string;
    costPrice?: number;
    departmentCode?: number;
    lineCode?: number;
    classCode?: number;
    subclassCode?: number;
    departmentName?: string;
    lineName?: string;
    className?: string;
    subclassName?: string;
    lowerLimit?: number;
    competitorName?: string;
    lowestSellingPrice?: number;
    discountedLowestSellingPrice?: number;
    lowestPriceType?: ChangeRequestResult.lowestPriceType;
    lowestPriceTypeName?: string;
    effectiveEndDate?: string;
    requestSellingPrice?: number;
    discountedRequestSellingPrice?: number;
    salesStartDate?: string;
    salesEndDate?: string;
    remandReason?: string;
    linkedItemFlag?: boolean;
    compensation?: string;
    stopPurchaseFlag?: string;
    saratokuSellingPrice?: number;
    discountedSaratokuSellingPrice?: number;
    chomeSellingPrice?: number;
    edlpSellingPrice?: number;
    discountedEdlpSellingPrice?: number;
    nbpbkbn?: number;
    pbleFlag?: boolean;
    tenDiscountFlag?: boolean;
    thirtyDiscountFlag?: boolean;
    fiftyDiscountFlag?: boolean;
    expandSalesFloor?: ChangeRequestResult.expandSalesFloor;
    packingCategory?: ChangeRequestResult.packingCategory;
    saleType?: ChangeRequestResult.saleType;
    reportFlag?: boolean;
    freshnessReason?: string;
    competitorStoreCode?: string;
    otherSpecialReports?: string;
    taxRate?: number;
    capacityOfUnit?: number;
    quantityOfUnit?: number;
    discountedCategory?: string;
    unit?: string;
    nextDayFlag?: boolean;
    exception?: boolean;
    prohibited?: boolean;
};
export namespace ChangeRequestResult {
    export enum lowestPriceType {
        EDLP = 'EDLP',
        SARATOKU = 'SARATOKU',
        CHOME = 'CHOME',
        COMPETITOR = 'COMPETITOR',
        FRESHNESS = 'FRESHNESS',
        POS_CHANGED = 'POS_CHANGED',
        ORIGINAL_SELLING_PRICE_CHANGE = 'ORIGINAL_SELLING_PRICE_CHANGE',
        NULL = 'NULL',
        EMPTY = 'EMPTY',
    }
    export enum expandSalesFloor {
        REGULAR = 'REGULAR',
        END = 'END',
        WAGON = 'WAGON',
        FLYER = 'FLYER',
    }
    export enum packingCategory {
        SINGLE_ITEM = 'SINGLE_ITEM',
        BALL = 'BALL',
        CASE = 'CASE',
        BUNDLE = 'BUNDLE',
        OTHER = 'OTHER',
    }
    export enum saleType {
        DAILY = 'DAILY',
        WEEKLY = 'WEEKLY',
        WEEKEND = 'WEEKEND',
        MONTHLY = 'MONTHLY',
        OTHER = 'OTHER',
    }
}

